export const getEntrancePage = () => {
  return RouteName.myWorksheet
}

export const RouteName = {
  button: '/button-test',
  root: '/',
  login: '/login',

  guestLogin: '/f4c8a9e7b5d1a6f3', // 외부 시연용 계정 세팅, magic 로그인 경로
  seoltabLogin: '/seoltab', // 설탭, magic 로그인 경로
  mathflatCallback: '/mathflat/callback', // 매쓰플랫 연동 콜백

  passwordReset: '/password-reset',
  passwordResetValid: '/password-reset/valid/:token',
  passwordResetExpired: '/password-reset/expired',
  passwordResetCompleted: '/password-reset/completed',
  phoneAuth: '/phone-auth/:status',

  // 수업준비
  lessonPreparation: '/lesson-preparation', // 수업준비
  worksheet: '/lesson-preparation/worksheet', // 수업준비 - 학습지
  myWorksheet: '/lesson-preparation/worksheet/my-worksheet', // 내 학습지
  favoriteWorksheet: '/lesson-preparation/worksheet/favorite-worksheet', // 즐겨찾기
  workbook: '/lesson-preparation/workbook', // 교재

  // 학습지 만들기
  makeWorksheet: '/make-worksheet',
  makeWorksheetBy: '/make-worksheet/by',
  makeWorksheetByChapter: '/make-worksheet/by/chapter', // 단원 유형별
  editWorksheetProblems: '/make-worksheet/edit/:filterId', // 2단계
  workSheetOptions: '/make-worksheet/options/:filterId', // 3단계

  // --------

  // 기관
  academy: '/academy', // 기관 기본
  academyManage: '/academy/manage', // 운영 관리
  studentManage: '/academy/manage/student', // 학생 관리
  classManage: '/academy/manage/class', // 반 관리
  createClass: '/create-class', // 반 생성
  modifyClass: '/modify-class/:classId', // 반 수정
  teacherManage: '/academy/manage/teacher', // 선생님 관리
  academyAuthManage: '/academy/manage/auth', // 권한설정
  academyOptionsManage: '/academy/manage/options', // 기관설정
  customer: '/mypage/customer', // 고객지원
  customerNotice: '/mypage/customer/notice', // 공지 및 업데이트
  customerFaq: '/mypage/customer/faq', // 자주묻는 질문
  customerQna: '/mypage/customer/qna', // 1:1질문

  // --------

  // 수업
  lesson: '/lesson',

  // 수업 - 학습지
  lessonWorksheet: '/lesson/worksheet',
  lessonWorksheetStudent: '/lesson/worksheet/student/:studentId',
  lessonWorksheetGrade: '/lesson/worksheet/grade/:gradeKey',
  lessonWorksheetClass: '/lesson/worksheet/lesson-class/:lessonClassId',

  // n차 학습지
  lessonWorksheetDerivation: '/student-derivation/:derivationType/:studentId', // 2차 학습지만들기 (단원, 기간별)
  derivationByChapter: '/student-derivation/by-chapter/:studentId',
  derivationByDate: '/student-derivation/by-date/:studentId',
  derivationByWorksheet: '/student-derivation/by-worksheet/:studentId',

  // 학습지 그룹 채점
  lessonWorksheetGroupScoring: '/group-scoring/:groupStudentWorksheetId',

  // class: '/class',
  // studentRegister: '/class/studentRegister',
  // groupManager: '/class/groupManager',
  // sms: '/sms',
  // auth: '/auth',

  // attendance: '/attendance',
  // teacher: '/teacher',
  // guide: '/guide',
  // guideDesktop: '/guide-Desktop',
  // publicBook: '/publicbook',

  // sheets: '/sheets',
  // custombook: '/custombook',
  // recommend: '/recommend',
  // mocktest: '/mocktest',

  // share: '/share',
  // makebook: '/makebook',
  // makepiece: '/makepiece',
  // makeMocktest: '/make-mocktest',
  // makePublicbook: '/make-publicbook',
  // editProblems: '/editProblems', // 교재만들기, 학습지만들기 2단계
  // printOptions: '/printOptions', // 교재만들기, 학습지만들기 3단계

  // history: '/lesson/history',
  // textbook: '/lesson/textbook',
  // textpaper: '/lesson/textpaper',
  // report: '/lesson/report',

  myInfo: '/mypage', // 내정보
  myUserInfo: '/mypage/user-info', // 내정보
guide: '/mypage/guide', // 사용가이드

  serverMaintenance: '/server-maintenance', // 서버 점검 화면
  // myinfoUpdate: '/myinfo-update',
  // myinfoPassword: '/myinfo-password',
  // noticeBrowserGuide: '/notice-browser-guide',
  // contract: '/contract-initial',
  // password: '/password',
  // notice: '/notice'

  // 웹뷰 관련
  webview: '/webview',
  // 수업 - 기타
  designTemplate: '/webview/design-template',

  // Tally 폼 임베드 (개인정보 URL 노출 방지용 래퍼)
  tallyEmbed: '/tally-embed',
} as const

export const routeNameInKor = (path: string) => {
  const kor = {
    login: '로그인',
    'password-reset': '비밀번호찾기',
    valid: '2단계 - 토큰정상',
    expired: '2단계 - 토큰만료',
    completed: '3단계 - 완료',
    'phone-auth': '문자인증',
    success: 'NICE_성공_후_도착화면',

    init: '초기셋팅',
    logo: '1단계',
    'confirm-academy-logo': '학원로고등록_완료 화면',
    'extra-info': '2단계',

    // 수업준비
    'lesson-preparation': '수업준비',
    worksheet: '학습지',
    'my-worksheet': '내학습지',
    'favorite-worksheet': '즐겨찾기',
    workbook: '교재',
    'my-workbook': '내교재 ',
    'public-workbook': '시중교재',
    // 학습지 만들기
    'make-worksheet': '학습지만들기',
    by: '1단계',
    chapter: '단원유형별',
    edit: '2단계',
    options: '3단계',

    // 관리
    academy: '관리',
    student: '학생',
    class: '반',
    'create-class': '반_생성',
    'modify-class': '반_수정',
    teacher: '선생님',
    auth: '권한설정',
    // '/options': '관리설정',
    manage: '운영',

    customer: '고객지원',
    notice: '공지및업데이트',
    faq: '자주묻는 질문',
    qna: '1:1질문',
    'support-workbook-list': '지원교재목록',
    review: '후기',
    lesson: '수업',
    grade: '학년',
    'lesson-class': '반',

    // n차 학습지
    'student-derivation': '단원유형별오답관리',
    // 학습지 그룹 채점
    'group-scoring': '학습지그룹채점',

    mypage: '프로필',
    'user-info': '내정보',

  }[path]

  return kor ? kor : path
}

export const fullModalRoutes: Array<string> = [
  RouteName.makeWorksheet,
  RouteName.createClass,
  RouteName.modifyClass,
  RouteName.derivationByChapter,
  RouteName.derivationByDate,
  RouteName.derivationByWorksheet,
]

export const PUBLIC_ROUTES = [RouteName.passwordReset, RouteName.phoneAuth]

/**
 * @description 로그인 페이지로 리다이렉트 하지 않아야 하는 경로
 */
export const NOT_ALLOWED_TO_REDIRECT_TO_LOGIN_PATH = [RouteName.root, RouteName.workSheetOptions]

export const SCREEN_SIZE_GUIDE_EXCLUDE_ROUTES = [RouteName.phoneAuth]

export const AUTH_ROUTES = [
  RouteName.login,
  RouteName.guestLogin,
  RouteName.seoltabLogin,
  RouteName.mathflatCallback,
]

export type AuthRoute = (typeof AUTH_ROUTES)[number]

export const 수능_콘텐츠_업데이트_경로 = RouteName.myWorksheet
